export default __webpack_public_path__ + "static/media/noa-47.d4937bd6.jpg";